module.exports = __webpack_public_path__ + "static/media/home-active.c56bca75.svg";